import { Component, OnInit } from '@angular/core';
import { IviMy23SharedService } from '../ivi-my23-shared.service';

@Component({
    selector: 'app-ivi-my23-renew-error-screen',
    templateUrl: './ivi-my23-renew-error-screen.component.html',
    styleUrls: ['./ivi-my23-renew-error-screen.component.scss'],
    standalone: false
})
export class IviMy23RenewErrorScreenComponent implements OnInit {
 isAcura: boolean = false;

  constructor(private iviDataService: IviMy23SharedService) { }

  ngOnInit(): void {
    this.isAcura = this.iviDataService.isAcura();
  }

}
